"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var colors = {
  white: '#ffffff',
  base: '#ffffff',
  primary: {
    dark: '#CF004F',
    base: '#117B53',
    light80: '#0B400A',
    light70: '#A14E78',
    light60: '#AE678B',
    light: '#BC819F'
  },
  secondary: {
    dark: '#8B9446',
    base: '#9BAB4D',
    light: '#ABC156'
  },
  black: '#212121',
  darkGrey: '#545454',
  grey: '#9E9E9E',
  lightGrey: '#A6A6A6',
  error: '#EE0033',
  lawOffWhiteBg: '#F8F5EF',
  headerBgColor: '#F8F5EF',
  halfblack: '#0000008a'
};
var fonts = {
  primary: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
  heading: '"Oswald", "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif'
};
var wpeTheme = {
  brandTag: 'wpe',
  colors: _objectSpread({}, colors),
  fonts: _objectSpread({}, fonts),
  bodyClasses: {
    body1: {
      fontFamily: fonts.primary,
      fontSize: '20px',
      lineHeight: '32px',
      letterSpacing: '0.5px',
      medium: {
        letterSpacing: '0.25px'
      }
    },
    body2: {
      fontFamily: fonts.primary,
      fontSize: '18px',
      lineHeight: '28px',
      letterSpacing: '0.5px'
    },
    body3: {
      fontFamily: fonts.primary,
      fontSize: '17px',
      lineHeight: '28px',
      letterSpacing: '0.5px'
    },
    body4: {
      fontFamily: fonts.primary,
      fontSize: '16px',
      lineHeight: '26px',
      letterSpacing: '0.25px',
      medium: {
        letterSpacing: '0.5px'
      },
      regular: {
        letterSpacing: '0.5px'
      }
    },
    body5: {
      fontFamily: fonts.primary,
      fontSize: '15px',
      medium: {
        letterSpacing: '0.5px',
        lineHeight: '26px'
      },
      regular: {
        letterSpacing: '0.25px',
        lineHeight: '28px'
      },
      light: {
        letterSpacing: '0.5px',
        lineHeight: '28px'
      }
    },
    body6: {
      fontFamily: fonts.primary,
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '.5px'
    }
  },
  button: {
    borderRadius: '3px',
    fontFamily: fonts.primary,
    letterSpacing: '.15px',
    lineHeight: '16px',
    buttonType: {
      ghost: {
        border: 'none',
        active: {
          backgroundColor: 'transparent',
          textColor: colors.primary.base
        },
        disabled: {
          borderColor: '',
          backgroundColor: 'transparent',
          textColor: colors.grey
        },
        hover: {
          backgroundColor: 'transparent',
          textColor: colors.primary.light80
        },
        pressed: {
          backgroundColor: 'transparent',
          textColor: colors.black
        }
      },
      primary: {
        border: "1px solid ".concat(colors.primary.base),
        active: {
          backgroundColor: colors.primary.base,
          textColor: colors.white
        },
        disabled: {
          borderColor: colors.grey,
          backgroundColor: colors.grey,
          textColor: colors.white
        },
        hover: {
          backgroundColor: colors.primary.light80,
          textColor: colors.white
        },
        pressed: {
          backgroundColor: colors.primary.light80,
          textColor: colors.white
        }
      },
      secondary: {
        border: "1px solid ".concat(colors.secondary.dark),
        active: {
          backgroundColor: colors.secondary.base,
          textColor: colors.white
        },
        disabled: {
          backgroundColor: colors.grey,
          textColor: colors.white
        },
        hover: {
          backgroundColor: colors.secondary.light,
          textColor: colors.white
        },
        pressed: {
          backgroundColor: colors.secondary.dark,
          textColor: colors.white
        }
      },
      tertiary: {
        border: "1px solid ".concat(colors.primary.base),
        active: {
          backgroundColor: colors.white,
          textColor: colors.black
        },
        disabled: {
          borderColor: colors.grey,
          backgroundColor: colors.white,
          textColor: colors.grey
        },
        hover: {
          backgroundColor: colors.primary.base,
          textColor: colors.white
        },
        pressed: {
          backgroundColor: colors.primary.light80,
          textColor: colors.white
        }
      }
    },
    buttonSize: {
      "default": {
        fontSize: '16px',
        height: '48px',
        padding: '0px 50px'
      },
      large: {
        fontSize: '16px',
        height: '56px',
        padding: '0px 40px'
      },
      small: {
        fontSize: '16px',
        height: '44px',
        padding: '0px 20px'
      }
    }
  },
  input: {
    fontFamily: fonts.primary,
    fontSize: '14px',
    border: '1px solid rgba(0, 0, 0, 0.16)',
    labelColor: colors.halfblack,
    inputColor: colors.black,
    focus: {
      border: "2px solid #0066FF"
    },
    hover: {
      border: "1px solid ".concat(colors.darkGrey)
    },
    active: {
      border: "1px solid ".concat(colors.grey)
    }
  },
  links: {
    fontFamily: fonts.primary,
    fontSize: '15px',
    letterSpacing: '0.25px',
    active: {
      textColor: colors.primary.base,
      textDecoration: 'none'
    },
    hover: {
      textColor: colors.primary.light80,
      textDecoration: 'underline'
    },
    pressed: {
      textColor: colors.primary.light80,
      textDecoration: 'underline'
    },
    disabled: {
      textColor: colors.grey,
      textDecoration: 'none'
    }
  },
  dropdown: {
    labelColor: colors.halfblack,
    selectedValueColor: colors.darkGrey,
    optionColor: colors.darkGrey,
    optionHoverTextColor: colors.black
  },
  headings: {
    h1: {
      fontFamily: fonts.heading,
      lineHeight: '56px',
      letterSpacing: '0px',
      fontWeight: 'bold',
      fontSize: '48px'
    },
    h2: {
      fontFamily: fonts.heading,
      lineHeight: '48px',
      letterSpacing: '0px',
      fontWeight: 'bold',
      fontSize: '40px'
    },
    h3: {
      fontFamily: fonts.heading,
      lineHeight: '48px',
      letterSpacing: '0.25px',
      fontWeight: 'bold',
      fontSize: '36px'
    },
    h4: {
      fontFamily: fonts.heading,
      lineHeight: '40px',
      letterSpacing: '0.25px',
      fontWeight: 'bold',
      fontSize: '32px',
      medium: {
        fontWeight: '500'
      }
    },
    h5: {
      fontFamily: fonts.heading,
      lineHeight: '32px',
      letterSpacing: '0.25px',
      fontWeight: 'bold',
      fontSize: '24px',
      medium: {
        fontWeight: 'normal'
      }
    },
    h6: {
      fontFamily: fonts.heading,
      lineHeight: '28px',
      letterSpacing: '1.0px',
      fontWeight: 'normal',
      fontSize: '20px',
      light: {
        fontWeight: '300'
      }
    }
  }
};
var _default = exports["default"] = wpeTheme;